export default __webpack_public_path__ + "static/media/mernBlog.70dd0396.png";